import DraftsList from "components/Drafts/DraftsList";
import { getDraftUiStrings, resolveDraftLocale } from "i18n/draftUi";

export default function UserProfileDrafts() {
  const ui = getDraftUiStrings(resolveDraftLocale());

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-4">
      <DraftsList heading={ui.draftsHeading} />
    </div>
  );
}
